<template>
  <ul class="gallery-tag-list">
    <li
      class="tag"
      v-for="tag in tags">

      <router-link :to="{ name: 'galleries', query: { tags: '' + tag.id } }">
        {{ tag.name }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'gallery-tag-list',

    props: {
      tags: {
        type: Array,
        // [ { id, name } ]
      }
    },

    data() {
      return {};
    }
  }
</script>

<style lang="scss" scoped>
  .gallery-tag-list {
    padding-top: 10px;
  }

  .tag {
    display: inline-block;

    > a {
      background: transparent;
      border: solid 1px #33ccff;
      border-radius: 4px;
      color: #33ccff;
      display: inline-block;
      padding: 4px 8px;
      margin: 0 5px 10px 0;
      height: auto;
      font-size: 12px;
      &:hover {
        background-color: #33ccff;
        color: #222222;
        text-decoration: none;
      }
      &::before {
        content: '#'
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GalleryTagList.vue?5255a866